const updateFavicon = async (url) => {
  if (url !== null && url !== "" && url !== undefined) {
    const favicon = document.getElementById("favicon");
    if (favicon) favicon.href = url;
  }
};

export default updateFavicon;
